export default __webpack_public_path__ + "static/media/b5.cbffa443.svg";